// Autogenerated by `yarn version-file`. DO NOT EDIT
export var VERSION = '1.16.9';